<template>
    <div>{{ $t('errorText') }}</div>
</template>

<script>
export default {
    name: 'error',
    created() {
        this.$router.push({name: 'error'});
    }
};
</script>

<style scoped>
</style>


<i18n>
    {
        "tr": {
            "errorText": "Sayfa bulunamadı"
        },
        "en": {
            "errorText": "Page is not found"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Error.vue